<i18n src="./resources/locales.json"></i18n>

<template>
  <v-dialog
    v-model="isContactsDialogOpen"
    width="350"
    content-class="sms-contacts-selection-dialog"
    @click:outside="close"
    scrollable
  >
    <v-card color="surface lighten-1">
      <v-card-title>
        {{ `${$t('title')} ${numContactsOrEmpty}` }}
        <v-btn class="close-btn" text icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="custom-scrollbar">
        <SmsContactList
          :max-list-height="maxListHeight"
          read-only-list
          use-custom-actions
          always-show-actions
          hide-contact-card
        >
          <template v-slot:contactActions="{ contact }">
            <v-checkbox
              :input-value="isContactChecked(contact)"
              :value="isContactChecked(contact)"
              @click.stop.prevent="addContactToSelectedList(contact)"
            />
          </template>
          <template v-slot:groupActions="{ group }">
            <v-checkbox
              :value="isGroupChecked(group)"
              :input-value="isGroupChecked(group)"
              :indeterminate="isGroupIndeterminate(group)"
              @click.stop.prevent="addGroupContactsToSelectedList(group)"
            />
          </template>
        </SmsContactList>
      </div>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="selectedContacts.length === 0" class="sms-primary-button" @click="selectContacts">
          {{ $t('selectContacts') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SmsContactList from '@/components/SmsContactList/SmsContactList';

export default {
  name: 'SmsContactSelectDialog',

  components: { SmsContactList },

  data() {
    return {
      searchString: '',
      contactsSections: [],
      currentUserContacts: [],
      enterpriseContacts: [],
      allGroups: [],
      selectedContacts: [],
      isContactsDialogOpen: false
    };
  },

  computed: {
    maxListHeight() {
      return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) - 300;
    },
    numContactsOrEmpty() {
      return this.selectedContacts.length ? `(${this.selectedContacts.length})` : '';
    }
  },

  methods: {
    open() {
      this.selectedContacts = [];
      this.isContactsDialogOpen = true;
    },

    close() {
      this.$emit('cancel-contact-selection');
      this.selectedContacts = [];
      this.isContactsDialogOpen = false;
    },

    selectContacts() {
      this.$emit('select-contact', this.selectedContacts);
      this.selectedContacts = [];
      this.isContactsDialogOpen = false;
    },

    _getNumberOfSelectedContactInGroup(groupToCheck) {
      const selectedContacts = groupToCheck.contacts.filter(contact =>
        this.selectedContacts.some(selectedContact => selectedContact.contactId === contact.contactId)
      );
      return selectedContacts.length;
    },

    isContactChecked(contact) {
      return this.selectedContacts.some(selectedContact => selectedContact.contactId === contact.contactId);
    },

    isGroupChecked(groupToCheck) {
      return groupToCheck.contacts.length > 0 && this._getNumberOfSelectedContactInGroup(groupToCheck) === groupToCheck.contacts.length;
    },

    isGroupIndeterminate(groupToCheck) {
      return (
        this._getNumberOfSelectedContactInGroup(groupToCheck) > 0 &&
        this._getNumberOfSelectedContactInGroup(groupToCheck) < groupToCheck.contacts.length
      );
    },

    addGroupContactsToSelectedList(groupToCheck) {
      const numberOfSelectedContacts = this._getNumberOfSelectedContactInGroup(groupToCheck);
      if (numberOfSelectedContacts < groupToCheck.contacts.length) {
        groupToCheck.contacts.forEach(contact => {
          if (!this.isContactChecked(contact)) {
            this.selectedContacts.push(contact);
          }
        });
      } else {
        this.selectedContacts = this.selectedContacts.filter(
          contact => !groupToCheck.contacts.some(groupContact => groupContact.contactId === contact.contactId)
        );
      }
    },

    addContactToSelectedList(contact) {
      if (!this.isContactChecked(contact)) {
        this.selectedContacts.push(contact);
      } else {
        this.selectedContacts = this.selectedContacts.filter(
          selectedContact => selectedContact.contactId !== contact.contactId
        );
      }
    }
  }
};
</script>

<style>
.sms-contacts-selection-dialog {
  border-radius: 10px !important;
  max-height: 100% !important;
  overflow: hidden;
}

.sms-contacts-selection-dialog .close-btn {
  position: absolute;
  right: 10px;
}
</style>
